export const NUMBER_OF_VIEWS = 5
